import React from 'react';
import ReserveFieldRecurring from '@/components/reserve/ReserveFieldRecurring/ReserveFieldRecurring';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormRecurringSelector: React.FC<{ isCompact?: boolean }> = ({
  isCompact = false
}) => {
  const { weekDates, form, office, resourceType } = useReserveForm();
  return (
    <ReserveFieldRecurring
      key={`${weekDates.map((x) => x.toString()).join(',') ?? ''}`}
      errors={form.formState.errors}
      defaultValue={''}
      form={form}
      isCompact={isCompact}
      office={office}
      resourceType={resourceType}
    />
  );
};
